/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Add_Recipient_TitleInputs */

const en_speakers_add_recipient_title = /** @type {(inputs: Speakers_Add_Recipient_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Recipient`)
};

const fr_speakers_add_recipient_title = /** @type {(inputs: Speakers_Add_Recipient_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un destinataire`)
};

const de_speakers_add_recipient_title = /** @type {(inputs: Speakers_Add_Recipient_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfänger hinzufügen`)
};

const it_speakers_add_recipient_title = /** @type {(inputs: Speakers_Add_Recipient_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi destinatario`)
};

const ru_speakers_add_recipient_title = /** @type {(inputs: Speakers_Add_Recipient_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить получателя`)
};

const es_speakers_add_recipient_title = /** @type {(inputs: Speakers_Add_Recipient_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar destinatario`)
};

const zh_cn2_speakers_add_recipient_title = /** @type {(inputs: Speakers_Add_Recipient_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加收件人`)
};

const ja_speakers_add_recipient_title = /** @type {(inputs: Speakers_Add_Recipient_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受信者を追加`)
};

const hi_speakers_add_recipient_title = /** @type {(inputs: Speakers_Add_Recipient_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्राप्तकर्ता को जोड़ें`)
};

const pt_pt2_speakers_add_recipient_title = /** @type {(inputs: Speakers_Add_Recipient_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar destinatário`)
};

/**
* | output |
* | --- |
* | "Add Recipient" |
*
* @param {Speakers_Add_Recipient_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_add_recipient_title = /** @type {((inputs?: Speakers_Add_Recipient_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Add_Recipient_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_add_recipient_title(inputs)
	if (locale === "de") return de_speakers_add_recipient_title(inputs)
	if (locale === "it") return it_speakers_add_recipient_title(inputs)
	if (locale === "ru") return ru_speakers_add_recipient_title(inputs)
	if (locale === "es") return es_speakers_add_recipient_title(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_add_recipient_title(inputs)
	if (locale === "ja") return ja_speakers_add_recipient_title(inputs)
	if (locale === "hi") return hi_speakers_add_recipient_title(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_add_recipient_title(inputs)
	return en_speakers_add_recipient_title(inputs)
});